import React, {  useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from '@mui/material'
// Material UI

import LandMarkImportList from '../landmarkImportList'
import LandmarkImportEdit from '../landmarkImportEdit';



const LandmarkImportDetail = (props) => {
    // Intl
    const { messages } = useIntl();
    const { callBack,handleClose,resumeTransactions } = props;
    // Hooks
    const dispatch = useDispatch();
    // State local
    const [fileDataCsv, setFileDataCsv] = useState(resumeTransactions);

    const getData = (data) => {
        let resume = fileDataCsv.filter(d => d.id !== data.id);
        
        if (resume.length == 0) {
            handleClose();
        }else{
            callBack(resume)
        }
        setFileDataCsv(resume)
    }

    return (
        <div  style={{ height: 650,overflow:'auto' }}>
            <div >
                <Typography variant="body2" color="textSecondary">
                    {messages['mapLandmarkImport_titleEditImport']}
                </Typography>

                {
                    fileDataCsv?.map((row, index) => {
                        if (row.error) {
                            return (
                                <LandMarkImportList data={row} key={index} callBack={getData} />
                            )
                        }

                    })
                }
            </div>
            <LandmarkImportEdit callBack={getData} />
        </div>
    );
}

export default LandmarkImportDetail;